import {connect} from 'pwa-helpers';
import {LitElement, html} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {msg, str} from '@lit/localize';

import {navigator, router} from 'lit-element-router';
import style from '../../../../scss/seriesListItem.scss';
import listStyle from '../../../../scss/list.scss';
import store from '../../store';
import {selectProfileDefaultLanguage, selectLanguage, selectCurrentContentLanguage} from '../../selectors';
import {deleteSeries, selectAllSerie} from '../../slices/artworkSlice';
import {routeUrl} from '../../util/routeUrl';
import {navigateTo, openDialog} from '../../slices/statusSlice';
import {getValueForLanguage} from '../../util/getValueForLanguage';
import getRoutes from '../../routes';

@customElement('arc-series-list-item')
export class SeriesListItem extends connect(store)(router(navigator(LitElement))) {
	static styles = [listStyle, style];
	static properties = {
		serie: {type: Array},
	};

	constructor() {
		super();
		this.serie = [];
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.lang = selectLanguage(state);
		this.currentLanguage = selectCurrentContentLanguage(state);
	}
	static get routes() {
		return getRoutes();
	}
	router(route, params, query, data) {
		this.route = route;
		this.params = params;
	}

	handleEditSeries() {
		store.dispatch(navigateTo({route: 'series-detail', params: {...this.params, ...{seriesId: this.serie.id, mode: 'edit'}}}));
	}

	async handleDeleteSeries() {
		const title = getValueForLanguage(this.serie.title, this.lang, true);
		store.dispatch(
			openDialog({
				title: msg('Remove Series'),
				warningMessage: msg(
					str`Removing Series "${title}" will immediately delete it. The artworks in this series remain in the artwork list.`
				),
				labelConfirm: msg('Remove Series'),
				labelCancel: msg('Cancel'),
			})
		);
		this._handleConfirm = async () => {
			await store.dispatch( deleteSeries({id: this.serie.id}));
			this.series = selectAllSerie(this.state);
			window.removeEventListener('confirm', this._handleConfirm);
		};
		window.addEventListener('confirm', this._handleConfirm);
	}


	render() {
		return html`

			<div class="listItem" @click="${this.handleEditSeries}">
				<div>
					<arc-image
						class="seriesImage"
						.noZoom=${true}
						.file=${this.serie.firstImage}
						alt="${getValueForLanguage(
							this.serie.firstImage?.info?.alt,
							this.currentLanguage,
							true
						)}"
					>
					</arc-image>
				</div>
				<div class="title">
						${getValueForLanguage(this.serie.title, this.currentLanguage, true)}
				</div>
				<div>
					${this.serie.artworksAmount}
				</div>
			</div>
			<div class="listButtons">
				<arc-dropdown-menu>
					<arc-button
						type="listMenu"
						title="${msg('Remove')}"
						@click=${this.handleDeleteSeries}>
						${msg('Remove')}
					</arc-button>
				</arc-dropdown-menu>
			</div>
    `;
	}
}
